import { render, staticRenderFns } from "./InformeCalendarioTab.vue?vue&type=template&id=18e02834"
import script from "./InformeCalendarioTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeCalendarioTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports